import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Widget } from '@model';
import { environment } from '@environment';
import { SxErrorService } from 'app/services/sx-error.service';
import { WidgetLoaderConfiguration } from '../../../models/widget-loader-configuration';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  load(payload: WidgetLoaderConfiguration): Observable<Widget[]> {
    return this.http
      .post<Widget[]>(`${environment.apiEndpoint}/WidgetData`, payload)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getAvailableWidgets(): Observable<Widget[]> {
    return this.http
      .get<Widget[]>(`${environment.apiEndpoint}/WidgetData/AvailableWidgets`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
